package us.laantech.common.util

import com.ionspin.kotlin.bignum.decimal.BigDecimal
import com.ionspin.kotlin.bignum.decimal.DecimalMode
import com.ionspin.kotlin.bignum.decimal.RoundingMode
import com.ionspin.kotlin.bignum.decimal.toBigDecimal
import kotlin.math.abs


fun Long.toDollarStrFromCents(): String {
    // TODO migrate to .toPlainString()
    val isNegative = this < 0
    val absVal = abs(this)
    val dollars = absVal / 100
    val cents = absVal % 100
    val sign = if (isNegative) "- " else ""
    val display = "${sign}${dollars}.${cents.toString().padStart(2, '0')}"
    return display
}

// not in KMP
//// Convert Decimal dollars to Long cents
fun BigDecimal.toLongCentsFromDollars(): Long {
    return this.times(100.toBigDecimal())
        .roundToDigitPositionAfterDecimalPoint(0, RoundingMode.ROUND_HALF_AWAY_FROM_ZERO)
        .longValue(exactRequired = false)}

fun Long.toBigDecimalDollarsFromCents(): BigDecimal {
    return this.toBigDecimal().divide(100.toBigDecimal(), DecimalMode.US_CURRENCY)
}

// TODO
//fun Double.toBigDecimalDollarsFromCents(): BigDecimal {
//    return this.toBigDecimal().movePointLeft(2)
//}